<sync-dialog
  [config]="{
    title: 'Upgrade to Sync Pro',
    isClosable: true,
    actionButton: 'View upgrade options',
    cancelButton: 'Cancel',
    onCancelClick: close,
    onActionClick: onClickUpgrade,
  }"
  [onClose]="close"
  [open]="open"
>
  <div class="upgrade-dialog">
    <p>Upgrade to Pro to instantly star more than 3 files.</p>

    <div class="features-cont">
      <span class="supercharge"><sync-icon name="star-badge" />Supercharge your Sync with these Pro features:</span>

      <div class="features">
        <span><sync-icon name="checkmark" /> Unlimited stars</span>
        <span><sync-icon name="checkmark" /> Go from gigabytes to terabytes of storage</span>
        <span><sync-icon name="checkmark" /> Unlimited sharing and file requests</span>
        <span><sync-icon name="checkmark" /> Up to 365-day version history</span>
        <span><sync-icon name="checkmark" /> Advanced sharing controls</span>
        <span><sync-icon name="checkmark" /> Collaborate in real time with our Microsoft Office integration</span>
      </div>
    </div>
  </div>
</sync-dialog>
